import React from 'react';
import { ToggleButton, Box, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { MenuOpen, Menu}  from '@mui/icons-material';

type Props = {
  isOpen?: boolean;
  children?: React.ReactNode;
};

export default function Sidebar(props: Props): JSX.Element {
  const [sidebarIsClosed, setSidebarIsClosed] = useState(!props.isOpen);

  return (
    <Box sx={{
        mt:2,
        flexGrow: 1,
        flexBasis: sidebarIsClosed ? "0" : "350px",
        width: sidebarIsClosed ? "0px" : "350px",
        padding: sidebarIsClosed ? 0 : "0 10px",
        position: "relative"
      }}>
      <Box sx={{
        position: "absolute",
        top: "0",
        right: sidebarIsClosed ? "-26px" : "-10px",
        zIndex: 100
      }}>
        <ToggleButton
          value="check"
          selected={sidebarIsClosed}
          onChange={() => {
            setSidebarIsClosed(!sidebarIsClosed);
            setTimeout(() => {
              window.dispatchEvent(new Event('resize'));
            }, 300);
          }} >
          { sidebarIsClosed ? <Menu /> : <MenuOpen /> }
        </ToggleButton>
      </Box>
      <Box sx={{visibility: sidebarIsClosed ? "hidden" : "visible"}}>
        <Paper>
          <Link to="/dashboard">
            <img style={{ height: "4rem", width: "auto", margin: "0 auto", display: "block" }} src="/img/Infegy_Logo_FullColor.svg" alt="Infegy Starscape logo" />
          </Link>
          {props.children}
        </Paper>
      </Box>
    </Box>
  );
}